import { BodyM, Description } from '@casavo/base-ui'
import useTranslation from 'next-translate/useTranslation'

import { CasavoAdvantage } from '@/containers/ListingDetail/CasavoAdvantage'

import { Translated } from '../Translated'

import { advantageCard, advantageIcon, advantageTitle } from './styles.css'

export const AdvantageCard: React.FC<{ advantage: CasavoAdvantage }> = ({ advantage }) => {
  const { t } = useTranslation()
  const title = t(advantage.titleTranslationKey)
  return (
    <div className={advantageCard}>
      <img alt={title} className={advantageIcon} src={advantage.iconUrl} style={{ height: advantage.imageSize }} />
      <BodyM strong className={advantageTitle}>
        {title}
      </BodyM>
      <Description>
        <Translated i18Key={advantage.descriptionTranslationKey} />
      </Description>
    </div>
  )
}
